import { render, staticRenderFns } from "./ConfirmMessage.vue?vue&type=template&id=46e18d44&scoped=true&"
import script from "./ConfirmMessage.vue?vue&type=script&lang=js&"
export * from "./ConfirmMessage.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmMessage.vue?vue&type=style&index=0&id=46e18d44&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46e18d44",
  null
  
)

export default component.exports